module.exports = __webpack_public_path__ + "static/media/0.99_wanliutwo.png";